<!-- <p>customers works!</p> -->

<app-example-wrapper-seamless sectionHeading="Customers">
    <div class="row">
        <div class="col-xl-12">
            <div class="card card-box mb-5">
                <div class="card-body">
                    <div class="d-flex justify-content-between pb-3">
                        <div class="search-wrapper">
                            <span class="icon-wrapper text-black">
                                <fa-icon [icon]="['fas', 'search']"></fa-icon>
                            </span>
                            <input type="text" class="form-control form-control-sm rounded-pill" placeholder="Search..."
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchText">
                        </div>
                        <div>
                            <button class="btn btn-sm btn-primary" type="button" (click)="addCustomer()"
                                id="addTeamMember">
                                <span class="btn-wrapper--icon">
                                    <fa-icon [icon]="['fas', 'plus']" class="opacity-8 font-size-xs" class="text-white">
                                    </fa-icon>
                                </span>
                                <span class="btn-wrapper--label">
                                    Add Customer
                                </span>
                            </button>
                            <button
                                    class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary ml-2"
                                    id="resFilterBtn"
                                    (click)="showFilter()"
                                    type="button">
                                <span class="btn-wrapper--label">Filters</span>
                                <span class="btn-wrapper--icon">
                                      <fa-icon *ngIf="!isShow" [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                                      <fa-icon *ngIf="isShow" [icon]="['fas', 'chevron-up']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                                    </span>
                            </button>
                            <button (click)="getData()" tooltip="Refresh" id="reloadEmployees"
                                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                type="button">
                                <span class="btn-wrapper--icon">
                                    <i class="ion-md-sync"></i>
                                </span>
                            </button>                            
                        </div>
                    </div>
                    <div *ngIf="allCustomerServices | tsearch:searchText; let filteredCustomers" >
                        <div *ngIf="isShow">
                            <form [formGroup]="filters_form" novalidate>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label> Status</label>
                                            <ng-select formControlName="status" [multiple]="true">
                                                <ng-option *ngFor="let status of statusList" [value]="status.value">
                                                    {{ status.label }}
                                                </ng-option>
                                            </ng-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group pt-4">
                                            <button class="btn mt-2 btn-sm btn-block btn-primary btn-square" type="button"
                                                    (click)="onSearch(filters_form.value)">Search</button>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group pt-4">
                                            <button class="btn mt-2 btn-sm btn-block btn-primary btn-square" type="button"
                                                    (click)="onClear()">Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="table-responsive table-scroll">
                            <table class="table table-hover table-striped table-bordered text-nowrap mb-3" [mfData]="filteredCustomers" #mf="mfDataTable" [mfRowsOnPage]="100"
                            [mfActivePage]="activePage">
                                <thead>
                                    <tr> 
                                        <th class="bg-white text-left"> Station </th>
                                        <th class="bg-white text-left"> Agency </th>
                                        <th class="bg-white text-left"> Customer Bill To(Company Name) </th>
                                        <th class="bg-white"> Customer Name </th>
                                        <th class="bg-white text-left"> Email </th>
                                       <!--  <th class="bg-white text-left"> Phone No </th>
                                         <th class="bg-white text-left"> Customer fax </th> 
                                        <th class="bg-white"> Customer Description </th>  
                                        <th class="bg-white text-left"> Address-1 </th>
                                        <th class="bg-white text-left"> Address-2 </th>
                                        <th class="bg-white"> State </th>
                                        <th class="bg-white text-left"> City </th>
                                        <th class="bg-white text-left"> Zipcode </th> 
                                        <th class="bg-white text-left"> Net Terms </th> -->
                                        <th class="bg-white text-left"> Chase Profile ID </th>
                                        <th class="bg-white text-left"> Transaction Type </th>
                                        <!-- <th class="bg-white text-left"> LCB ID </th> -->
                                        <th class="bg-white text-left">Promotional Contract</th>
                                        <th class="bg-white text-left"> Status </th>
                                        <th class="bg-white text-left">&nbsp;</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let cservice of mf.data; let i = index">
                                        <td class="text-left">{{cservice.STATION}}</td>
                                        <td class="text-left">{{cservice.AGENCY_NAME}}</td>
                                        <td class="text-left">{{cservice.COMPANY_NAME}}</td>
                                        <td class="text-left">{{cservice.CONTACT_NAME}}</td>
                                        <td class="text-left">{{cservice.CONTACT_EMAIL}}</td>
                                        <!-- <td class="text-left">{{cservice.CONTACT_PHONE}}</td>
                                         <td class="text-left">{{cservice.CONTACT_FAX}}</td>
                                        <td class="text-left">{{cservice.CUSTOMER_DESCRIPTION}}</td>
                                        <td class="text-left">{{cservice.ADDRESS1}}</td>
                                        <td class="text-left">{{cservice.ADDRESS2}}</td>
                                        <td class="text-left">{{cservice.STATE}}</td>
                                        <td class="text-left">{{cservice.CITY}}</td>
                                        <td class="text-left">{{cservice.ZIPCODE}}</td>
                                        <td class="text-left">{{cservice.NET_TERMS}}</td> -->
                                        <td class="text-left">{{cservice.PROF_CUST_REFNUM}}</td>
                                        <td class="text-left">{{cservice.TRANSACTION_TYPE}}</td>
                                        <!-- <td class="text-left">{{cservice.LCB_ID}}</td> -->
                                        <td class="text-left">{{cservice.promotional_contract}}</td>
                                        <td class="text-left">
                                            <span class="badge bg-neutral-dark text-success"
                                            *ngIf="cservice.ACTIVE==true">Active</span>
                                            <span class="badge bg-neutral-dark text-warning"
                                            *ngIf="cservice.ACTIVE==false">Inactive</span>
                                        </td>         
                                        <td class="text-left">
                                            <button class="btn btn-sm btn-neutral-dark" tooltip="Edit" type="button"
                                                (click)="editCustomerService(cservice)">
                                                <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="10">
                                            <span class="font-weight-bold text-primary">Total  Customer Services:
                                               {{filteredCustomers.length}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span class="font-weight-bold text-success">Active :
                                                {{calculateActiveCustomers(filteredCustomers)}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span class="font-weight-bold text-warning">Inactive :
                                                {{calculateInActiveCustomers(filteredCustomers)}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <mfBootstrapPaginator [rowsOnPageSet]="[200,400,600,800,1000]">
                                            </mfBootstrapPaginator>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-example-wrapper-seamless>
<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>


